import { Edition } from "./edition";
import { RenditionTypeInfo } from "./rendition-type-info";

export class EditionRenditionsInfo {
    public __classname__: string = 'EditionRenditionsInfo';

	public $Edition : Edition | null = null;
	public $Renditions : RenditionTypeInfo | null = null;

    constructor(
        $Edition: Edition | null = null,
        $Renditions: RenditionTypeInfo | null = null
    ) {
        this.$Edition = $Edition;
        this.$Renditions = $Renditions;
    }
}